export default "__VITE_ASSET__c73b69ba__"